import { render, staticRenderFns } from "./CarroselClimaMonitoramentoAgricola.vue?vue&type=template&id=664f2f9a&scoped=true&lang=pug"
import script from "./CarroselClimaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./CarroselClimaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./CarroselClimaMonitoramentoAgricola.vue?vue&type=style&index=0&id=664f2f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f2f9a",
  null
  
)

export default component.exports